module.exports = __webpack_public_path__ + "static/this-website-48c6c23ddd0914cf8f1f620f82638292.png";